<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
        </b-col>
      </b-row>
      <b-form @submit.prevent="saveItem">
        <b-row>
          <b-col cols="12">
            <b-alert :show="feedback.show" dismissible :variant="feedback.variant" @dismissed="feedback.show = 0"
                     @dismiss-count-down="countDownChanged">
              {{ feedback.text }}
              <ul v-if="errors" class="mt-3">
                <li v-for="error in errors">
                  {{ error.toString() }}
                </li>
              </ul>
            </b-alert>
          </b-col>
          <b-col cols="12">
            <b-card>
              <template #header>
                <span class="pull-left mt-2 mb-2"><strong>Locatie {{item.name}} (# {{item.id}})</strong></span>
                <b-button class="pull-right" variant="primary" v-can="'locaties aanpassen'" v-if="!editable"
                          @click="editable = true">Bewerken
                </b-button>
              </template>

              <b-row v-if="hasPettyCashOrders">
                <b-col cols="12">
                  <b-alert variant="info" :show="true">
                  Let op: Het bedrijf <strong>{{item.company.name}}</strong> heeft instelling <strong>Petty Cash</strong> (<em>herhaalopdrachten</em>) aan staan.
                  </b-alert>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="10" md="6">
                  <b-row>
                    <b-col cols="12" md="8">
                      <h5>Basisgegevens</h5>
                      <hr>
                    </b-col>
                    <b-col cols="12" sm="8" md="8">
                      <b-form-group label="Naam">
                        <b-form-input type="text" required v-model="item.name" :disabled="!editable || !userCanFullyEdit"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="4" md="4">
                      <b-form-group label="Code">
                        <b-form-input type="text" required v-model="item.code" :disabled="!editable || !userCanFullyEdit"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4" md="4">
                      <b-form-group label="Klantreferentie">
                        <b-form-input type="text" v-model="item.internal_reference"
                                      :disabled="!editable || !userCanFullyEdit"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" md="8">
                      <b-form-group label="Gekoppeld bedrijf">
                        <b-form-select :options="companyOptions" v-model="item.company_id"
                                       :disabled="!editable || !userCanFullyEdit"></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" sm="10" md="6" class="mb-2">
                  <b-row>
                    <b-col cols="12" md="8">
                      <h5>Adresgegevens</h5>
                      <hr>
                    </b-col>
                    <b-col cols="12" md="8">
                      <b-form-group label="Adres">
                        <b-form-input type="text" required v-model="item.address" :disabled="!editable || !userCanFullyEdit"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" md="3">
                      <b-form-group label="Postcode">
                        <b-form-input type="text" required v-model="item.postal_code"
                                      :disabled="!editable || !userCanFullyEdit"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="5">
                      <b-form-group label="Plaats">
                        <b-form-input type="text" required v-model="item.city" :disabled="!editable || !userCanFullyEdit"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" md="4">
                      <b-form-group label="Land">
                        <b-form-select :options="countryOptions" required v-model="item.country_code"
                                       :disabled="!editable || !userCanFullyEdit"></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mt-4" v-if="!(item.company && item.company.has_recurring_orders)">
                <b-col cols="12" sm="10" md="6">
                  <b-row>
                    <b-col cols="12" md="8">
                      <h5>Transport instellingen</h5>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" md="8">
                      <b-form-group label="Transport op afroep">
                        <b-form-checkbox v-model="item.transport_on_demand" name="transportOnDemand" value="1" switch
                                         :disabled="!editable">
                          <span
                            v-if="item.transport_on_demand">Ja, heeft <strong>wel</strong> transport op afroep</span>
                          <span v-else>Nee, heeft <strong>geen</strong> transport op afroep</span>
                        </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="8" md="8">
                      <b-form-group label="Schema actief vanaf">
                        <b-input-group>
                          <flat-pickr
                            v-model="item.settings_start_at"
                            :config="settingsStartAtInputConfig"
                            class="form-control"
                            :disabled="!editable"
                          />
                          <b-input-group-append>
                            <b-button size="sm"
                                      :disabled="!editable"
                                      @click="() => {if(editable) item.settings_start_at = null}">
                              <i class="icon-trash"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row v-else>
                <b-col cols="12" sm="10" md="6">
                  <b-row>
                    <b-col cols="12" md="8">
                      <h5>Herhaalopdrachten</h5>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row>
                    <recurring-setter :settings="item.recurring_settings" />
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="editable">
          <b-col cols="12" v-if="editable" class="mb-4">
            <b-card>
              <b-button type="submit" variant="primary" class="mr-3" :disabled="saveButtonDisabled">Wijzigingen
                opslaan
              </b-button>
              <b-button @click.prevent="cancelEdit">Annuleren</b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>

      <b-row class="mt-2 mb-4" v-if="!(item.company && item.company.has_recurring_orders)">
        <b-col cols="12" md="6" v-can="'locaties bekijken'">
          <delivery-slot-setter v-if="item.renewal_settings" :settings="item.renewal_settings"/>
        </b-col>
        <b-col cols="12" md="6" v-can="'locaties bekijken'">
          <delivery-slots :location-id="$route.params.id"></delivery-slots>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
  const weekSelect = require("flatpickr/dist/plugins/weekSelect/weekSelect.js")
  import {getData, updateData} from '../../api';
  import moment from 'moment';
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import DeliverySlots from "../delivery-slots/DeliverySlots";
  import DeliverySlotSetter from "../delivery-slots/DeliverySlotSetter";
  import RecurringSetter from "../delivery-slots/RecurringSetter";
  import {Dutch} from "flatpickr/dist/l10n/nl.js"
  import User from '../../classes/user';

  export default {
    name: 'location',
    components: {DeliverySlotSetter, DeliverySlots, RecurringSetter, flatPickr},
    props: ['id'],
    data() {
      return {
        saveButtonDisabled: false,
        settingsStartAtInputConfig: {
          locale: Dutch,
          dateFormat: 'W/Y',
          weekNumbers: true,
          plugins: [new weekSelect({})],
        },
        feedback: {
          show: false,
          text: '',
          variant: null,
          dismissCountDown: 4
        },
        editable: false,
        companyOptions: [],
        countryOptions: [],
        item: {
          transport_on_demand: false,
          recurring_settings: [],
        },
        errors: null,
      }
    },
    methods: {
      async getItem() {
        const item = await getData('locations/' + this.$route.params.id).then(response => response.data);
        this.item = {
          ...item.data,
          renewal_settings: item.data.renewal_settings.map((item) => {
            return {
              ...item,
              start_date: item.start_date ? moment(item.start_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
            }
          })
        }
      },
      async getCompanyOptions() {
        const options = await getData('companies/options').then(response => response.data);
        this.companyOptions = options.data;
      },
      async getCountries() {
        const countries = await getData('countries').then(response => response.data);
        this.countryOptions = countries.data;
      },
      async saveItem() {
        this.errors = null;
        this.saveButtonDisabled = true;
        const request = await updateData('locations/' + this.$route.params.id, this.item);
        if (request.status === 200) {
          this.feedback.show = true;
          this.feedback.text = 'Locatie succesvol geupdate';
          this.feedback.variant = 'success';
          this.editable = false;
          this.saveButtonDisabled = false;
        } else {
          this.errors = request.data.errors;
          this.feedback.show = true;
          this.feedback.text = 'Er ging iets mis...';
          this.feedback.variant = 'danger';
          this.editable = true;
          this.saveButtonDisabled = false;
        }
      },
      cancelEdit() {
        this.editable = false;
        this.getItem();
      },
      countDownChanged(dismissCountDown) {
        this.feedback.dismissCountDown = dismissCountDown
      },
      showAlert() {
        this.this.feedback.dismissCountDown = this.dismissSecs
      },
    },
    beforeMount() {
      this.getItem();
      this.getCompanyOptions();
      this.getCountries();
    },
    computed: {
      userRole() {
        return this.$store.state.userRole
      },
      userCanFullyEdit() {
        return User.can('locaties volledig aanpassen');
      },
      hasPettyCashOrders() {
        const result = this.item && this.item.company && this.item.company.has_recurring_orders || false;
        return result;
      }
    },
  }

</script>

<style>
  .flatpickr-input[readonly]:not([disabled]){
    background: #FFF;
  }
  .flatpickr-input[disabled]{
    cursor: default;
  }
</style>
